import { camelCase } from 'es-toolkit';
import { Table } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import { TABLE_COLUMNS } from '.';

export const DEFAULT_LEADS_PER_PAGE = 10;

const SkeletonCell = () => (
  <SkeletonContainer>
    <Bone css={{ marginBlock: 'tight' }} />
  </SkeletonContainer>
);

const SkeletonRow = ({ cellCount }: { cellCount: number }) => (
  <Table.Row>
    {Array.from({ length: cellCount }, (_, index) => (
      <Table.Cell key={index}>
        <SkeletonCell />
      </Table.Cell>
    ))}
  </Table.Row>
);

type LeadManagementTableSkeletonProps = {
  numberOfRows?: number;
  showHeader?: boolean;
};

export default function LeadManagementTableSkeleton({
  numberOfRows,
  showHeader = true,
}: LeadManagementTableSkeletonProps) {
  const SKELETON_ROWS = Array(numberOfRows || DEFAULT_LEADS_PER_PAGE).fill('');

  return (
    <Table.Root aria-label="Leads" appearance="horizontal" size="lg">
      {showHeader && (
        <Table.Header>
          <Table.Row>
            {TABLE_COLUMNS.map((name) => {
              const colId = camelCase(name);
              return (
                <Table.HeaderCell key={colId} css={{ paddingLeft: name === 'Name' ? '75px' : '' }}>
                  {name}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
      )}

      <Table.Body>
        {SKELETON_ROWS.map((_, index) => (
          <SkeletonRow key={index} cellCount={TABLE_COLUMNS.length} />
        ))}
      </Table.Body>
    </Table.Root>
  );
}
